/**
 * File vertical-slides.js.
 *
 * Vertical Slide magic.
 *
 * @package wildrivers
 */
import { elementIsVisibleInViewport } from './in-viewport';

export function verticalSlides() {
	const slideSets = document.querySelectorAll(
		'.wildrivers-vertical-slides .static-slides'
	);

	const body = document.getElementsByTagName('body')[0];
	if (!slideSets?.length || body.classList.contains('wp-admin') ) {
		return;
	}

	slideSets.forEach((slideSet) => {
		const imageSlides = slideSet.querySelectorAll(
			'.slide-images .static-slide--image'
		);
		const contentSlides = slideSet.querySelectorAll(
			'.slide-content .static-slide--content'
		);

		if (!imageSlides.length || !contentSlides.length) {
			return;
		}

		const syncImageHeights = () => {
			const isMobile = window.innerWidth < 768;

			imageSlides.forEach((imageSlide) => {
				const img = imageSlide.querySelector('img');
				const wrapper = imageSlide.parentElement;

				// On desktop and larger: clear any inline heights.
				if (isMobile) {
					imageSlide.style.height = '';
					if (wrapper) {
						wrapper.style.height = '';
					}
					return;
				}

				// Below 768px: match the wrapper heights to the image height.
				if (!img) {
					return;
				}

				const setHeight = () => {
					const rect = img.getBoundingClientRect();

					if (rect.height > 0) {
						imageSlide.style.height = `${rect.height}px`;
						if (wrapper) {
							wrapper.style.height = `${rect.height}px`;
						}
					}
				};

				if (img.complete) {
					setHeight();
				} else {
					img.addEventListener('load', setHeight, { once: true });
				}
			});
		};

		const updateActiveSlide = () => {
			let activeIndex = -1;

			const isMobile = window.innerWidth < 768;
			const imagesWrapper = slideSet.querySelector('.static-slide--image'); // first image
			const imagesRect = imagesWrapper
				? imagesWrapper.getBoundingClientRect()
				: null;

			contentSlides.forEach((contentSlide, index) => {
				const rect = contentSlide.getBoundingClientRect();
				
				if ( 0 === index ) {
					if ( rect.top < imagesRect.y ) {
						slideSet.dataset.scrolled="true";
					} else {
						slideSet.dataset.scrolled="false";
					}
				}

				if (activeIndex !== -1) {
					return;
				}

				if (isMobile && imagesRect) {
					// On small screens, only treat content as "active"
					// when it is visible in the area *below* the image.
					const midY = (rect.top + rect.bottom) / 2;
					const zoneTop = imagesRect.bottom;
					const zoneBottom = window.innerHeight;

					if (midY >= zoneTop && midY <= zoneBottom) {
						activeIndex = index;
					}
				} else if (elementIsVisibleInViewport(contentSlide, true)) {
					// Default behaviour for >= 768px: any partial visibility in viewport.
					activeIndex = index;
				}
			});

			// Mobile: if we're scrolled above the slideSet (haven't reached any content yet),
			// keep the first image visible.
			if (activeIndex === -1 && isMobile) {
				const setRect = slideSet.getBoundingClientRect();

				if (setRect.top >= 0) {
					activeIndex = 0;
				}
			}

			imageSlides.forEach((imageSlide, index) => {
				if (index === activeIndex) {
					imageSlide.classList.add('is-active');
				} else {
					imageSlide.classList.remove('is-active');
				}
			});
		};

		// Initial state.
		syncImageHeights();
		updateActiveSlide();

		// Update on scroll and resize.
		window.addEventListener('scroll', updateActiveSlide, { passive: true });
		window.addEventListener('resize', () => {
			syncImageHeights();
			updateActiveSlide();
		});
	});
}
